import { Box, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as HumCartSvg } from "../../../../assets/svg/HumCart-Shopping.svg";
import { ReactComponent as HumCartSvg2 } from "../../../../assets/svg/HumCart-Shopping2.svg";
import { secondary } from "../../../../themes/theme";

interface IProps {
  id: string;
  title: string;
  description?: string;
}

const LoginUI: React.FC<IProps> = ({ id, title, description }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        background: secondary[100],
        // borderRight:`1px dashed ${secondary[300]}`
      }}
    >
      <Box sx={{ px: 1, mx: 1, mb: 2 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Poppins",
            fontWeight: "bold",
            textAlign: "center",
            color: secondary[900],
            my: 1,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: "Poppins",
            fontWeight: "450",
            textAlign: "center",
            color: secondary[600],
          }}
        >
          {description}
        </Typography>
      </Box>
      <Box sx={{ width: "100%", maxWidth: "470px", px: 1, mx: 1, my: 2,p:2, }}>
        {id === "login" ? (
          <HumCartSvg2 />
        ) : id === "register" ? (
          <HumCartSvg />
        ) : (
          <HumCartSvg2 />
        )}
      </Box>
    </Box>
  );
};

export default LoginUI;
